import { useQuery } from "urql";

import { ClikCountriesDocument } from "../../../graphql/generated.ts";

export function useClikCountries() {
  return useQuery({ query: ClikCountriesDocument });
}
